module.exports = __webpack_public_path__ + "static/media/TezexLogo.519afb98.svg";